module.exports = __webpack_public_path__ + "static/img/arrow-left.ac029de9.svg";